import React from 'react';
import { clp, fechaLarga } from '../utiles/fechas.js';
import { Pase } from './Pase.jsx';

export function Confirm({ sede, date, time, reserva, go }) {
  const s = sede;
  return (
    <div className="wrap confirm">
      <div className="check">
        <svg viewBox="0 0 24 24">
          <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <h1>Reserva confirmada</h1>
      <p className="c-sub">Te esperamos, {reserva.nombre.split(' ')[0]}.</p>

      {reserva.pase ? (
        <Pase pase={reserva.pase} sede={s} fecha={date} hora={time}
              equipo={reserva.equipo} cliente={reserva.nombre}
              precioFinal={reserva.precioFinal} />
      ) : null}

      <div className="resumen">
        <div className="res-row"><span className="k">Centro</span><span className="v">{s.nombre}</span></div>
        <div className="res-row"><span className="k">Dirección</span><span className="v">{s.direccion}</span></div>
        <div className="res-row"><span className="k">Día</span><span className="v">{fechaLarga(date)}</span></div>
        <div className="res-row"><span className="k">Hora</span><span className="v">{time}</span></div>
        <div className="res-row"><span className="k">Equipo</span><span className="v">{reserva.equipo}</span></div>
      </div>

      <div className="pay-note">
        El pago se realiza en el centro ({clp(reserva.precioFinal ?? s.precio_tune)}
        {reserva.precioFinal != null ? ', con tu descuento aplicado' : ''}).
        Llega 5 minutos antes para acomodarte con calma.
      </div>
      <button className="btn ghost block" onClick={() => go('home')}>Volver al inicio</button>
    </div>
  );
}
